import {
  Routes,
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType
} from 'react-router-dom';

import {
  createReactRouterV6Options,
  getWebInstrumentations,
  initializeFaro,
  ReactIntegration,
} from '@grafana/faro-react';

import { TracingInstrumentation } from '@grafana/faro-web-tracing';

initializeFaro({
  url: '/faro/collect',
  app: {
    name: window.APP_CONFIG?.faroAppName || 'platform-jokes',
  },
  instrumentations: [
    ...getWebInstrumentations(),

    new TracingInstrumentation(),

    new ReactIntegration({
      router: createReactRouterV6Options({
        createRoutesFromChildren,
        matchRoutes,
        Routes,
        useLocation,
        useNavigationType,
      }),
    }),
  ],
});

